import Phaser from 'phaser';
import type { GameState } from '../types';
import { computePyramidLayout } from '../game/pyramid';
import { CardSprite } from './CardSprite';

export interface PyramidViewOptions {
  pyramidTop: number;
  pyramidHeight: number;
  onCardTap: (cardId: string) => void;
}

export class PyramidView {
  scene: Phaser.Scene;
  container: Phaser.GameObjects.Container;
  cardSprites = new Map<string, CardSprite>();
  options: PyramidViewOptions;

  constructor(scene: Phaser.Scene, state: GameState, options: PyramidViewOptions) {
    this.scene = scene;
    this.options = options;
    this.container = scene.add.container(0, 0);

    const layout = computePyramidLayout({
      viewportWidth: scene.scale.width,
      viewportHeight: scene.scale.height,
      pyramidTop: options.pyramidTop,
      pyramidHeight: options.pyramidHeight,
    });

    for (const cardLayout of layout.cards) {
      const card = state.pyramid.find(
        (c) => c.row === cardLayout.row && c.col === cardLayout.col
      );
      if (!card) continue;
      const sprite = new CardSprite(scene, card, cardLayout);
      sprite.setOnTap(() => options.onCardTap(card.id));
      this.cardSprites.set(card.id, sprite);
    }
  }

  refresh(state: GameState): void {
    for (const sprite of this.cardSprites.values()) {
      sprite.refresh(state);
    }
  }
}
